export type Environment = "next-js" | "vite" | "unknown";

export type SupabaseConfig = {
	supabaseUrl: string;
	supabaseKey: string;
};

const DefaultProductionSupabaseConfig: SupabaseConfig = {
	supabaseUrl: "https://rjcogfxactzvhldzuxfb.supabase.co",
	supabaseKey:
		"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJqY29nZnhhY3R6dmhsZHp1eGZiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDIyNjgwNzEsImV4cCI6MjAxNzg0NDA3MX0.2-nMK_XS-8PKSb0AixNS-8lToPB4d4mczFoeNWBln68",
};

// Read Vite env via destructuring (the only import.meta form webpack supports).
// Wrapped in try/catch because import.meta.env is undefined under webpack/Next.js.
function getViteEnv(): Record<string, string | undefined> {
	try {
		// @ts-ignore - import.meta.env only exists in Vite
		const { env } = import.meta;
		return env ?? {};
	} catch {
		return {};
	}
}

export class ConfigService {
	getEnvironment(): Environment {
		if (
			process?.env?.NEXT_PUBLIC_SUPABASE_URL != null &&
			process?.env?.NEXT_PUBLIC_SUPABASE_ANON_KEY != null
		) {
			return "next-js";
		}

		const viteEnv = getViteEnv();
		if (
			viteEnv.VITE_SUPABASE_URL != null &&
			viteEnv.VITE_SUPABASE_ANON_KEY != null
		) {
			return "vite";
		}

		return "unknown";
	}

	getSupabaseConfig(): SupabaseConfig {
		const environment = this.getEnvironment();

		switch (environment) {
			case "next-js":
				return {
					supabaseUrl: process.env.NEXT_PUBLIC_SUPABASE_URL ?? "",
					supabaseKey: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ?? "",
				};
			case "vite": {
				const viteEnv = getViteEnv();
				return {
					supabaseUrl: viteEnv.VITE_SUPABASE_URL ?? "",
					supabaseKey: viteEnv.VITE_SUPABASE_ANON_KEY ?? "",
				};
			}
			default:
				return DefaultProductionSupabaseConfig;
		}
	}
}
